import { defineMessages } from "react-intl";

export const messages = defineMessages({
  dates: {
    id: "ari.management.dateRange.dates",
    defaultMessage: "Dates"
  },
  fromDate: {
    id: "ari.management.dateRange.fromDate",
    defaultMessage: "From date"
  },
  toDate: {
    id: "ari.management.dateRange.toDate",
    defaultMessage: "To date"
  },
  monday: {
    id: "ari.management.dateRange.monday",
    defaultMessage: "Mon"
  },
  tuesday: {
    id: "ari.management.dateRange.tuesday",
    defaultMessage: "Tue"
  },
  wednesday: {
    id: "ari.management.dateRange.wednesday",
    defaultMessage: "Wed"
  },
  thursday: {
    id: "ari.management.dateRange.thursday",
    defaultMessage: "Thu"
  },
  friday: {
    id: "ari.management.dateRange.friday",
    defaultMessage: "Fri"
  },
  saturday: {
    id: "ari.management.dateRange.saturday",
    defaultMessage: "Sat"
  },
  sunday: {
    id: "ari.management.dateRange.sunday",
    defaultMessage: "Sun"
  },
  addPeriod: {
    id: "ari.management.dateRange.addPeriod",
    defaultMessage: "Add period"
  }
});